import { BARCLAYS_SAVE_DATA } from "./types";

export function saveBarclaysData({ data }) {
  return { type: BARCLAYS_SAVE_DATA, data };
}
